import styles from "./index.module.scss";
import appStore from "../../assets/appStore.png";
import googlePlay from "../../assets/googlePlay.png";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import SupportView from "../Support/SupportView";

export default function MobileView() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/support" element={
          <div className={styles.support}>
            <a href="/" className={styles.backLink}>← Скачать приложение</a>
            <SupportView />
          </div>
        } />
        <Route path="*" element={<DownloadView />} />
      </Routes>
    </BrowserRouter>
  );
}

function DownloadView() {
  return (
    <div className={styles.area}>
      <div className={styles.background} />
      <div className={styles.flite} />
      <div className={styles.load}>Скачайте приложение</div>
      <div className={styles.links}>
        <a href="https://apps.apple.com/by/app/flite-mobile/id6739353128" target="__blank">
          <img src={appStore} alt="appStore" />
        </a>
        <a href="https://play.google.com/store/search?q=flite%20mobile&c=apps&hl=ru" target="__blank">
          <img src={googlePlay} alt="googlePlay" />
        </a>
      </div>
      <a href="/support" className={styles.supportLink}>Поддержка</a>
    </div>
  );
}
